import React from "react";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

// A field's label, above the field and always visible (docs/ui-standard.md §4).
const CustomFormLabel = styled(({ color, ...props }) => (
  <Typography variant="subtitle2" fontWeight={600} {...props} component="label" htmlFor={props.htmlFor} style={{ color: color ?? null }} />
))(({ theme }) => ({
  marginBottom: "6px",
  marginTop: "16px",
  display: "block",
  color: theme.palette.text.primary,
}));

export default CustomFormLabel;
